import {EventEmitter, Injectable, NgZone} from '@angular/core';
import {AngularFireAuth} from '@angular/fire/auth';
import {ActivatedRoute, NavigationEnd, NavigationStart, Router} from '@angular/router';
import {Observable, Subject} from 'rxjs';
import {User} from '../../model/user';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public user: User;

  constructor(public firebaseAuth: AngularFireAuth,
              private router: Router,
              private ngZone: NgZone,
              private matSnackBar: MatSnackBar) {
    this.firebaseAuth.authState.subscribe(user => {
      // const saveLogin = localStorage.getItem('saveLogin');
      // if (saveLogin === undefined || saveLogin === null || saveLogin === 'false') {
      //   this.signOut();
      // }
      if (user) {
        this.user = user;
        localStorage.setItem('user', JSON.stringify(this.user));
      } else {
        localStorage.setItem('user', null);
      }
    });

  }


  get isLoggedIn() {
    const user = JSON.parse(localStorage.getItem('user'));
    return user !== null && user !== undefined;
  }

  public signIn(email: string, password: string, saveLogin?) {
    return this.firebaseAuth
      .signInWithEmailAndPassword(email, password)
      .then((result) => {
        this.ngZone.run(() => {
          this.router.navigate(['vorhersagen']);
        });
        localStorage.setItem('saveLogin', saveLogin);
        this.user = JSON.parse(JSON.stringify(result.user));
        localStorage.setItem('user', JSON.stringify(this.user));
        this.openSnackBar(`Sie sind angemeldet als: ${result.user.email}`, 'OK');
      })
      .catch(err => {
        localStorage.setItem('user', null);
        this.openSnackBar(`Login fehlgeschlagen: ${err.message}`, 'OK');
      });
  }

  public signOut() {
    this.firebaseAuth.signOut().then(() => {
      this.ngZone.run(() => {
        this.router.navigate(['login']);
      });
      localStorage.setItem('user', null);
      this.openSnackBar('Logout erfolgreich', 'OK');
    }).catch(err => {
      this.openSnackBar(`Logout fehlgeschlagen: ${err.message}`, 'OK');
    });
  }

  private openSnackBar(message: string, action: string) {
    this.matSnackBar.open(message, action, {duration: 2500})
  }


}
